import React from 'react'

function NotFoundPage() {
  return (
    <h1 style={{ textAlign : 'center',margin : '150px 0' }}>404 Not Found</h1>
  )
}

export default NotFoundPage